import { createStyles, makeStyles, Theme } from '@forgeglobal/design-framework';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    valuationGreetings: {
      padding: theme.spacing(3, 5),
      background: theme.palette.background.paper,
      border: `1px solid ${theme.palette.divider}`,
      borderRadius: 4,
      marginBottom: theme.spacing(3),
    },
    title: {
      paddingBottom: theme.spacing(1),
    },
    rmdText: {
      marginTop: theme.spacing(3),
    },
  })
);
